import { computed } from '@vue/composition-api';
import type { ComputedRef } from '@vue/composition-api';
import { useStore } from '@/hooks/useStore';
import { LocalStorageActionTypes, LocalStorageGetterTypes } from '@/store/modules/localStorage';

const LAST_STANDBY_TYPE_KEY = LocalStorageGetterTypes.HOKKAIDO_AIRPORT_LAST_STANDBY_TYPE;

export const useLastStandbyType = (): {
  lastStandbyType: ComputedRef<string>;
  saveLastStandbyType: (standbyType: string) => void;
} => {
  const store = useStore();

  const lastStandbyType = computed<string>(() => store.getters[LAST_STANDBY_TYPE_KEY] ?? '');
  const saveLastStandbyType = (standbyType: string): void => {
    store.dispatch(LocalStorageActionTypes.SET, { key: LAST_STANDBY_TYPE_KEY, val: standbyType });
  };

  return { lastStandbyType, saveLastStandbyType };
};
